import React from 'react';
import { Tag, TagProps } from '@grubhubprod/gh-cookbook-react';
import { Control, RegisterOptions, useController } from 'react-hook-form';

export interface CookbookTagWrapperProps extends TagProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
}

export const CookbookTagWrapper = ({
  name,
  control,
  rules,
  onClick,
  ...cookbookTagProps
}: CookbookTagWrapperProps): JSX.Element => {
  const { field } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? false,
  });

  return (
    <Tag
      {...cookbookTagProps}
      onClick={(e): void => {
        field.onChange(!field.value);
        onClick?.(e);
      }}
      selected={Boolean(field.value)}
    />
  );
};
